// /centers DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. enum(종류 / 유형 / 상태)은 StatusChip 매핑으로 표시한다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip } from "components/list";
import { ICenter } from "../interfaces";
import { resolveKindOf, resolveEstType, resolveStatus } from "./centersStatus";

export const centersColumns: GridColDef<ICenter>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
    filterable: false,
  },
  // 이름: 약 50자까지 노출 후 ellipsis (15px 폰트 실측 50자 ≈ 570px + 좌우 패딩 20px)
  {
    field: "name",
    headerName: "이름",
    width: 600,
    minWidth: 600,
  },
  {
    field: "kindOf",
    headerName: "종류",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveKindOf(params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  // 주소: 약 20자까지 노출 후 ellipsis (15px 폰트 실측 20자 ≈ 235px + 좌우 패딩 20px)
  { field: "address", headerName: "주소", width: 260, minWidth: 260 },
  { field: "tel", headerName: "전화번호", width: 140, minWidth: 120 },
  { field: "sido", headerName: "시도", width: 133, minWidth: 110 },
  { field: "sigungu", headerName: "시군구", width: 120, minWidth: 100 },
  {
    field: "estType",
    headerName: "유형",
    width: 110,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveEstType(params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "status",
    headerName: "상태",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatus(params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  { field: "updatedDate", headerName: "수정일", width: 236, minWidth: 190 },
];
